<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <div v-if="getUserData && getUserData.email" class="btn btn-light mr-2">
        <i class="fa fa-user mr-2" />{{ getUserData.email }}
      </div>
    </template>
    <template slot="dropdown">
      <router-link class="dropdown-item" :to="{ name: 'Common.MyAccount' }">
        <i class="fa fa-user" /> My Account
      </router-link>
      <b-dropdown-item @click="logout">
        <i class="fa fa-lock" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters('account', [
      'getUserData',
      'isLoggedIn'
      // ...
    ])
  },
  methods: {
    logout() {
      localStorage.removeItem('refreshToken');
      this.$cookie.set('auth_token', '');
      this.$cookie.delete('auth_token');
      let lastTka = this.$cookie.get('auth_token');
      this.$store.dispatch('account/logout');
      //this.$router.push({ name: 'Login', query: { '_r': (Math.random().toString(36).substr(2, 5)) } });
      window.location.replace('/login?_r='+ (Math.random().toString(36).substr(2, 5)));
    }
  }
};
</script>
